import React from "react";
import { Modal, Button, ConfigProvider } from "antd";

export const BulkDeleteConfirmationModal = ({
  open,
  selectedRows,
  users,
  onConfirm,
  onCancel
}) => {
  return (
    <Modal
      title={
        <div className="h-[3rem] flex items-center text-[#27272a] text-[1.5rem] font-[700] font-[Inter]">
          Delete
        </div>
      }
      open={open}
      onCancel={onCancel}
      centered
      width={480}
      styles={{ content: { borderRadius: "1.5rem" } }}
      footer={[
        <ConfigProvider
          theme={{ token: { colorLink: "#3f3f46" } }}
          key="cancel-provider"
        >
          <Button
            type="link"
            onClick={onCancel}
            style={{
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "24px",
              color: "#3f3f46",
              paddingInline: "8px",
            }}
          >
            Cancel
          </Button>
        </ConfigProvider>,
        <ConfigProvider key="delete-provider">
          <Button
            type="primary"
            key="delete"
            onClick={onConfirm}
            danger
            style={{
              padding: "0.5rem 1.5rem",
              borderRadius: "1.25rem",
              height: "2.5rem",
              backgroundColor: "#df0101",
              color: "#fff",
              fontFamily: "Inter",
              fontWeight: 500,
            }}
          >
            Delete
          </Button>
        </ConfigProvider>,
      ]}
    >
      <div className="flex flex-col gap-4 items-start pt-[1.5rem]">
        {selectedRows.length > 0 &&
          (() => {
            const selectedUsers = users.filter((user) =>
              selectedRows.includes(user.key)
            );
            const uniqueUsers = [
              ...new Map(selectedUsers.map((u) => [u.userId, u])).values(),
            ];
            const nameText =
              uniqueUsers.length === 1
                ? uniqueUsers[0].name
                : `${uniqueUsers.length} users`;

            return (
              <div className="text-black text-[1rem] font-[400]">
                Are you sure you want to delete{" "}
                <strong>{nameText}</strong> from{" "}
                <strong>DashONE</strong>? This will permanently remove{" "}
                {uniqueUsers.length === 1 ? "the user" : "these users"}.
              </div>
            );
          })()}
        <div className="w-full h-[1px] bg-[#EAEAED]" />
      </div>
    </Modal>
  );
};
